document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('.section-nav');
    if (!nav) return;

    const titleWrapper = nav.querySelector<HTMLDivElement>('.section-nav__title-wrapper');
    const titleToggle = nav.querySelector<HTMLButtonElement>('.section-nav__title-toggle');
    const dropdownsWrapper = nav.querySelector<HTMLDivElement>('.section-nav__dropdowns-wrapper');

    // Toggle full nav open/closed (mobile & collapsed desktop)
    if (titleWrapper && titleToggle && dropdownsWrapper) {
        const toggleMenu = () => {
            const isOpen = dropdownsWrapper.classList.toggle('menu-open');
            titleToggle.setAttribute('aria-expanded', String(isOpen));
            titleWrapper.classList.toggle('menu-open', isOpen);
        };

        titleToggle.addEventListener('click', () => {
            // Always active on mobile, only on desktop if collapsed-nav is present
            if (window.innerWidth < 992 || nav.classList.contains('collapsed-nav')) {
                toggleMenu();
            }
        });
    }

    // Dropdowns: handle click vs hover toggle logic
    const dropdowns = nav.querySelectorAll<HTMLDivElement>('.section-nav__dropdown');

    dropdowns.forEach(dropdownEl => {
        const toggleBtn = dropdownEl.querySelector<HTMLButtonElement>('.section-nav__dropdown-toggle');
        const menu = dropdownEl.querySelector<HTMLUListElement>('.dropdown-menu');

        // Skip link-only or mobile title dropdowns
        if (!toggleBtn || !menu) return;

        // MOBILE BEHAVIOR (click to toggle)
        toggleBtn.addEventListener('click', e => {
            // Prevent click from triggering navigation or hover logic
            e.preventDefault();

            // On mobile OR collapsed desktop
            if (window.innerWidth < 992 || nav.classList.contains('collapsed-nav')) {
                const isOpen = menu.classList.toggle('show');
                toggleBtn.setAttribute('aria-expanded', String(isOpen));
            }
        });

        // Overflow adjustment (for large dropdowns near viewport edge)
        dropdownEl.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 992 && !nav.classList.contains('collapsed-nav')) {
                menu.classList.remove('dropdown-overflow-left', 'dropdown-overflow-right', 'ready');

                requestAnimationFrame(() => {
                    const rect = menu.getBoundingClientRect();
                    if (rect.right > window.innerWidth) {
                        menu.classList.add('dropdown-overflow-right');
                    } else if (rect.left < 0) {
                        menu.classList.add('dropdown-overflow-left');
                    }
                    menu.classList.add('ready');

                    toggleBtn.setAttribute('aria-expanded', 'true');
                });
            }
        });

        dropdownEl.addEventListener('mouseleave', () => {
            const isDesktopHoverMode = window.innerWidth >= 992 && !nav.classList.contains('collapsed-nav');
            if (!isDesktopHoverMode) return;

            toggleBtn.setAttribute('aria-expanded', 'false');
        });
    });
});